import type { ReactNode } from 'react';
import { KnolskapeLogo } from './KnolskapeLogo';

interface EducateNavHeaderProps {
  eyebrow: string;
  title: string;
  showLogo?: boolean;
  children: ReactNode;
}

const RAINBOW =
  'linear-gradient(90deg,#f5c518 0%,#ff7a00 20%,#ff2d55 40%,#8b5cf6 60%,#2563eb 80%,#16a34a 100%)';

export function EducateNavHeader({
  eyebrow,
  title,
  showLogo = true,
  children
}: EducateNavHeaderProps) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-100 text-slate-900">
      <div className="sticky top-0 z-30 shadow-[0_4px_16px_-4px_rgba(15,23,42,0.12)]">
        <div className="h-1 w-full shrink-0" style={{ background: RAINBOW }} aria-hidden="true" />

        <header className="shrink-0 border-b border-slate-200 bg-white">
          <div className="flex items-center justify-between gap-4 px-[15%] py-3.5">
            <div className="min-w-0">
              <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-600">
                {eyebrow}
              </p>
              <h1 className="mt-0.5 truncate text-xl font-bold text-slate-900 sm:text-2xl">
                {title}
              </h1>
            </div>
            {showLogo && <KnolskapeLogo className="hidden shrink-0 sm:flex" />}
          </div>
        </header>
      </div>

      {children}
    </div>
  );
}
